import { useMutation } from '@tanstack/react-query';

import { serviceTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';

export const removeService: serviceTypes.RemoveServiceData = ({ _id }) => {
  return axios.delete(`/services/${_id}`);
};

type QueryFnType = typeof removeService;

type UseRemoveServiceOptions = {
  department: Departments;
  config?: MutationConfig<(params: Parameters<QueryFnType>[0]) => ReturnType<QueryFnType>>;
};

export function useRemoveService({ config = {}, department }: UseRemoveServiceOptions) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['services', department]);
    },
    ...config,
    mutationFn: removeService,
  });
}
